import React from 'react';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import TimezoneSelect, { i18nTimezones } from 'react-timezone-select';
import 'moment-timezone';
var timeZones = moment.tz.names();
var offsetTmz = [];
const format = 'h:mm a';
let start;
let ROUNDING = 30 * 60 * 1000; /*ms*/
start = moment();
start = moment(Math.ceil((+start) / ROUNDING) * ROUNDING);
let userRole;
let offertypeVal;
let mediumVal;
let medium_ = [];
let Source_List = [];
let dollar_Cost = [];
let offer_Type = [];
let source_Provider;
const options = [
    { value: 'Select Report', label: 'Select Report' },
    { value: 'external_partner_lead_detailed_report', label: 'External Partner Lead Detail Report' },
    { value: 'external_partner_lead_summary_report', label: 'External Partner Lead Summary Report' },
    { value: 'credit_lead_return_resason_report', label: 'Credit Leads Return Reason Report' },
    { value: 'interaday_external_partner_lead_detailed_report', label: 'Intraday External Partner Lead Detail Report' },
    { value: 'unique_student_report', label: 'Unique Student Report (Return Details)' },
    { value: 'real_time_lead_reject_reason', label: 'Real Time Lead Reject Reason' },
];
const month = [
    { id: 1, value: "January" },
    { id: 210, value: "February" },
    { id: 3, value: "March" },
    { id: 4, value: "April" },
    { id: 5, value: "May" },
    { id: 6, value: "June" },
    { id: 7, value: "July" },
    { id: 8, value: "August" },
    { id: 9, value: "September" },
    { id: 10, value: "October" },
    { id: 11, value: "November" },
    { id: 12, value: "December" },
];
const week = [
    { id: 1, value: "Monday" },
    { id: 222, value: "Tuesday" },
    { id: 3, value: "Wednesday" },
    { id: 4, value: "Thursday" },
    { id: 5, value: "Friday" },
    { id: 6, value: "Saturday" },
    { id: 7, value: "Sunday" },
]
const daterangeOptions = [
    { value: 'Custom', label: 'Custom' },
    { value: 'Yesterday', label: 'Yesterday' },
    { value: 'Last 7 days', label: 'Last 7 days' },
    { value: 'Last 30 days', label: 'Last 30 days' },
    { value: 'Last 60 days', label: 'Last 60 days' },
    { value: 'Last 90 days', label: 'Last 90 days' },
    { value: 'This week', label: 'This week' },
    { value: 'Last week', label: 'Last week' },
    { value: 'This Month', label: 'This Month' },
    { value: 'Last Month', label: 'Last Month' },
];
const sortByZone = (a, b) => {
    let [ahh, amm] = a.split("UTC")[1].split(")")[0].split(":");
    let [bhh, bmm] = b.split("UTC")[1].split(")")[0].split(":");
    return (+ahh * 60 + amm) - (+bhh * 60 + bmm)
};
console.log(moment.tz.guess());
const getTimeZoneList = moment.tz.names().map(t => `(UTC${moment.tz(t).format("Z")}) ${t}`);
const timezone = getTimeZoneList.sort(sortByZone);
for (var i in timezone) {
    const zonename = timezone[i].split(')').pop();
    offsetTmz.push({ label: timezone[i], value: zonename.trim() });

}

// const timezone = moment.tz.names();
// var timezone = Object.keys(moment.tz._zones)
//     .map(function(k) { return moment.tz._zones[k].split('|')[0]; })
//     .filter(function(z) { return z.indexOf('/') >= 0; })
//     .sort();
// for (var i in timezone) {
//     const zonecountry = timezone[i].split('/')[0];
//     const zonename = timezone[i].split('/').pop();
//     console.log(zonecountry);
//     offsetTmz.push({ label: zonename + ' / ' + zonecountry, value: timezone[i] });

// }


const get_token = localStorage.getItem("token");
const inpersonateFlag = localStorage.getItem("inpersonate");
const userTimezone = moment.tz.guess();

class Subscriptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: { label: 'Select Report', value: 'Select Report' },
            startDate: new Date(),
            endDate: new Date(),
            subscriptionstartDate: new Date(),
            subscriptionendDate: '',
            subscriptionselectDate: new Date(),
            daterangeoption: { label: 'Yesterday', value: 'Yesterday' },
            timezoneoption: { label: "(UTC" + moment.tz(userTimezone).format('Z') + ") " + userTimezone, value: userTimezone },
            medium: [],
            offerType: [],
            sourceList: [],
            dollarCost: [],
            dollar_Cost: [],
            reportList: [],
            Source_List: [],
            offer_Type: [],
            medium_: [],
            sourceProvider: { label: '', value: '' },
            selectMonth: new Date(),
            monthoption: [],
            reportTimeOption: 'Hourly',
            hourTimeOption: '',
            weekoption: [],
            deliverySubject: '',
            emailList: '',
            error_msg: false,
            // reportFormatOption:'',
            subscriptionTitle: '',
            errorsubscribe_msg: false,
            defaulttime: start,
            issubscribeLoader: false,
            issucessMEssage: '',
            SubscribeTitle: false,
            //ReportType: false,
            EmailList: false,
            Subject: false,
            ReportFormat: false,
            FollowingDays: false,
            FollowingMonths: false,
            FollowingHours: false,
            selectDate: false,
            Timeoption: false,
            startDateerror: false
        }
    }
    handleChange = selectedOption => {
        this.setState({ medium: [], offerType: [], sourceList: [], dollarCost: [] })
        let requestOptions = {
            method: "GET",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer' + get_token,
            },
        };
        let tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer' + get_token,
            },
        };
        this.setState({ issubscribeLoader: true });
        fetch(`./wp-json/asd/api/offer_type`, requestOptions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 404) {
                    this.setState({ issucessMEssage: "There are no offers.", issubscribeLoader: false });
                    return false
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {
                this.setState({ issubscribeLoader: false, offer_Type: data.data });
            })

        fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {

                this.setState({ issubscribeLoader: false, medium_: data.data });
            })

        fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {

                this.setState({ issubscribeLoader: false, Source_List: data.data });
            })

        fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {
                this.setState({ issubscribeLoader: false, dollar_Cost: data.data });
            })
        this.setState({ selectedOption });
        if (selectedOption.value == 'Select Report') {
            $(".report-select-options").addClass("subscription-hide-blk");
            this.setState({ ReportType: true });
        }
        else if (selectedOption.value == 'interaday_external_partner_lead_detailed_report' || 'intraday_linkout_lead_detail_report') {
            var daterangeoptio = { label: 'Today', value: 'Today' };
            $(".report-select-options").removeClass("subscription-hide-blk");
            this.setState({ daterangeoption: daterangeoptio, ReportType: false });
        } else if (selectedOption.value == 'unique_student_report') {
            $(".report-select-options").removeClass("subscription-hide-blk");
            let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
            let dt = new Date();
            dt.setDate(1);
            dt.setMonth(dt.getMonth() - 2);
            this.setState({ ReportType: false, startDate: y_date, selectMonth: dt, endDate: y_date, daterangeoption: { label: 'Yesterday', value: 'Yesterday' } });
        } else {
            let dt = new Date();
            $(".report-select-options").removeClass("subscription-hide-blk");
            let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
            this.setState({ ReportType: false, startDate: y_date, selectMonth: dt, endDate: y_date, daterangeoption: { label: 'Yesterday', value: 'Yesterday' } });
        }
    };
    onTimeChange = (defaulttime) => {
        //var time = defaulttime && defaulttime.format(format);
        this.setState({ defaulttime });
        if (defaulttime == null) {
            this.setState({ Timeoption: true });
        }
        else {
            this.setState({ Timeoption: false });
        }
    }
    timezoneplaceholder = timezoneoption => {
        this.setState({ timezoneoption: { label: 'Search available options .....', value: 'Search available options .....' } })
    }
    timezonehandleChange = timezoneoption => {
        this.setState({
            timezoneoption
        }, () => {
            $('.timezone-list .custom-select div input').blur(); console.log(this.state.timezoneoption.value);
        });
    }
    timezoneblurplaceholder = timezoneoption => {
        if (this.state.timezoneoption.value.includes("Search available options")) {
            this.setState({ timezoneoption: { label: "(UTC" + moment.tz(userTimezone).format('Z') + ") " + userTimezone, value: userTimezone } })
        }

    }

    presentDatehandleChange = daterangeoption => {
        this.setState({ daterangeoption });
        let { startDate, endDate } = this.state;
        if (daterangeoption.value == 'Custom') {
            $('.datepicker').removeClass("disabled");
        }
        else if (daterangeoption.value == 'Today') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: new Date(), endDate: new Date() })
        }
        else if (daterangeoption.value == 'Yesterday') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let y_date = new Date(new Date().setDate(new Date().getDate() - 1));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: y_date, endDate: y_date })

        }
        else if (daterangeoption.value == 'Last 7 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastseven_date = new Date(new Date().setDate(new Date().getDate() - 7));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastseven_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 30 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 30));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 60 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastthirty_date = new Date(new Date().setDate(new Date().getDate() - 60));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastthirty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last 90 days') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            let lastninty_date = new Date(new Date().setDate(new Date().getDate() - 90));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastninty_date, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'This week') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var curr = new Date;
            var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
            var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: firstday, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) })
        }
        else if (daterangeoption.value == 'Last week') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000)
            var beforeOneWeek2 = new Date(beforeOneWeek);
            var day = beforeOneWeek.getDay() + 1;
            var diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1);
            var lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))
            var lastSunday = new Date(beforeOneWeek2.setDate(diffToMonday + 6));
            $('.datepicker').addClass("disabled");
            this.setState({ startDate: lastMonday, endDate: lastSunday })
        }
        else if (daterangeoption.value == 'This Month') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var date = new Date();
            var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            this.setState({ startDate: firstDay, endDate: new Date(new Date().setDate(new Date().getDate() - 1)) });
            $('.datepicker').addClass("disabled");
        }
        else if (daterangeoption.value == 'Last Month') {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
            var now = new Date();
            var lastday = new Date(now.getFullYear(), now.getMonth(), 0);
            var firstday = new Date(lastday.getFullYear(), lastday.getMonth(), 1);
            this.setState({ startDate: firstday, endDate: lastday });
            $('.datepicker').addClass("disabled");
        }
        else {
            // $('.datepicker').addClass("disabled");
            $('.custom-date-lbl').addClass('lbl-hide');

        }

    };
    handleInputMonthChange = (event) => {
        const target = event.target;
        var value = target.value;
        if (target.checked) {
            this.state.monthoption.push(value);
        } else {
            this.state.monthoption.splice(this.state.monthoption.indexOf(value), 1)
        }
        if (event.target.value == '') {
            this.setState({ FollowingMonths: true });

        }
        else {
            this.setState({ FollowingMonths: false });
        }
    }

    handleDateChange(dateName, dateValue) {
        let { startDate, endDate } = this.state;
        if (dateName === 'startDateTime') {
            startDate = dateValue;
        } else {
            endDate = dateValue;
        }
        this.setState({
            startDate,
            endDate,
        });
        if (Date.parse(startDate) > Date.parse(endDate)) {
            this.setState({ error_msg: true });
            $('#formElem').addClass("disabled");
        }
        else {
            this.setState({ error_msg: false });
            $('#formElem').removeClass("disabled");
        }

    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    handlesubscribeDateChange(dateName, dateValue) {
        let { subscriptionstartDate, subscriptionendDate } = this.state;
        if (dateName === 'subscribeStartDateTime') {
            subscriptionstartDate = dateValue;
        } else {
            subscriptionendDate = dateValue;
        }
        this.setState({
            subscriptionstartDate,
            subscriptionendDate,
        }, () => {

            if (this.state.subscriptionendDate != '') {
                var date1, date2;
                if (this.state.subscriptionstartDate != null) {
                    date1 = new Date(this.state.subscriptionstartDate.toDateString());
                }
                if (this.state.subscriptionendDate != null) {
                    date2 = new Date(this.state.subscriptionendDate.toDateString());
                }
                if (date1 > date2) {
                    this.setState({ errorsubscribe_msg: true });
                    $('#formElem').addClass("disabled");
                }
                else {
                    this.setState({ errorsubscribe_msg: false });
                    $('#formElem').removeClass("disabled");
                }
            }

        });
    }
    handlesubscribeselectDateChange(dateName, dateValue) {
        let { subscriptionselectDate } = this.state;
        if (subscriptionselectDate == '') {
            this.setState({ selectDate: true });
        }
        else {
            this.setState({ selectDate: false });
        }
        if (dateName === 'SelectDate') {
            subscriptionselectDate = dateValue;
        }
        this.setState({ subscriptionselectDate });
    }
    handleInputWeekChange = (event) => {
        const target = event.target;
        var value = target.value;
        if (target.checked) {
            this.state.weekoption.push(value);
        } else {
            this.state.weekoption.splice(this.state.weekoption.indexOf(value), 1)
        }

        if (event.target.value == '') {
            this.setState({ FollowingDays: true });
        }
        else {
            this.setState({ FollowingDays: false });

        }
    }

    handleReportTimeChange = (event) => {
        this.setState({ reportTimeOption: event.target.value, monthoption: [], weekoption: [], hourTimeOption: [] });
    }
    // handleReportFormatChange =  (event) =>{ 
    //     this.setState({reportFormatOption: event.target.value});      
    //     if(event.target.value == ''){
    //         this.setState({ReportFormat: true});      
    //     }
    //     else{
    //         this.setState({ReportFormat: false});  
    //     }
    // }    
    handleHourTimeChange = (event) => {
        this.setState({ hourTimeOption: event.target.value })
        if (event.target.value == '') {
            this.setState({ FollowingHours: true });
        }
        else {
            this.setState({ FollowingHours: false });

        }
    }
    mediumhandleChange = (medium) => {
        if (!medium) {
            medium = [];
        }
        if (medium.length == 0 && (this.state.selectedOption.value === 'external_partner_lead_summary_report' || this.state.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.selectedOption.value === 'real_time_lead_reject_reason') && this.state.sourceList.length == 0) {
            let get_token = localStorage.getItem("token");
            let sourceVal = $('.hidden-lbl.source-lbl').text();
            let objArr = {}
            if ((sourceVal.trim()) != "") {
                objArr = { ['source']: sourceVal.trim() }
            }
            let tokenrequestOtions = {
                method: "POST",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objArr),
            };
            fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
                .then(response => response.json())
                .then(data => { this.setState({ medium_: data.data }); })
        }
        this.setState({ medium }, () => {
            if ((this.state.selectedOption.value === 'external_partner_lead_summary_report' || this.state.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.selectedOption.value === 'real_time_lead_reject_reason') && this.state.sourceList.length == 0) {
                let get_token = localStorage.getItem("token");
                let mediumVal = $('.hidden-lbl.medium-lbl').text();
                let objArr = {}
                if ((mediumVal.trim()) != "") {
                    objArr = { ['medium']: mediumVal.trim() }
                }
                let tokenrequestOtions = {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        'Authorization': 'Bearer' + get_token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(objArr),
                };
                fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
                    .then(response => response.json())
                    .then(data => { this.setState({ Source_List: data.data }); })
            }
        })
    };
    sourcehandleChange = (source) => {
        if (!source) {
            source = [];
        }
        if (source.length == 0 && this.state.medium.length == 0 && (this.state.selectedOption.value === 'external_partner_lead_summary_report' || this.state.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.selectedOption.value === 'real_time_lead_reject_reason')) {
            let get_token = localStorage.getItem("token");
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            let objArr = {}
            if ((dollarVal.trim()) != "") {
                objArr = { ['source']: dollarVal.trim() }
            }
            let tokenrequestOtions = {
                method: "POST",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objArr),
            };
            fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
                .then(response => response.json())
                .then(data => { this.setState({ Source_List: data.data }); })
        }
        if (source.length == 0 && this.state.dollarCost.length == 0 && this.state.selectedOption.value === 'unique_student_report') {
            let get_token = localStorage.getItem("token");
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            let objArr = {}
            if ((dollarVal.trim()) != "") {
                objArr = { ['source']: dollarVal.trim() }
            }
            let tokenrequestOtions = {
                method: "POST",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objArr),
            };
            fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
                .then(response => response.json())
                .then(data => { this.setState({ Source_List: data.data }); })
        }
        this.setState({ sourceList: source }, () => {
            if ((this.state.selectedOption.value === 'external_partner_lead_summary_report' || this.state.selectedOption.value === 'external_partner_lead_detailed_report' || this.state.selectedOption.value === 'interaday_external_partner_lead_detailed_report' || this.state.selectedOption.value === 'real_time_lead_reject_reason') && this.state.medium.length == 0) {
                let get_token = localStorage.getItem("token");
                let sourceVal = $('.hidden-lbl.source-lbl').text();
                let objArr = {}
                if ((sourceVal.trim()) != "") {
                    objArr = { ['source']: sourceVal.trim() }
                }
                let tokenrequestOtions = {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        'Authorization': 'Bearer' + get_token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(objArr),
                };
                fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
                    .then(response => response.json())
                    .then(data => { this.setState({ medium_: data.data }); })
            } else if ((this.state.selectedOption.value === 'unique_student_report') && this.state.dollarCost.length == 0) {
                let get_token = localStorage.getItem("token");
                let sourceVal = $('.hidden-lbl.source-lbl').text();
                let objArr = {}
                if ((sourceVal.trim()) != "") {
                    objArr = { ['source']: sourceVal.trim() }
                }
                let tokenrequestOtions = {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        'Authorization': 'Bearer' + get_token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(objArr),
                };
                fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
                    .then(response => response.json())
                    .then(data => { this.setState({ dollar_Cost: data.data }); })
            }
        });

    };
    dollarhandleChange = (dollar) => {
        if (!dollar) {
            dollar = [];
        }
        if (dollar.length == 0 && this.state.sourceList.length == 0) {
            let get_token = localStorage.getItem("token");
            let sourceVal = $('.hidden-lbl.source-lbl').text();
            let objArr = {}
            if ((sourceVal.trim()) != "") {
                objArr = { ['source']: sourceVal.trim() }
            }
            let tokenrequestOtions = {
                method: "POST",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objArr),
            };
            fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
                .then(response => response.json())
                .then(data => { this.setState({ dollar_Cost: data.data }); })
        }
        this.setState({ dollarCost: dollar }, () => {
            if ((this.state.selectedOption.value === 'unique_student_report') && this.state.sourceList.length == 0) {
                let get_token = localStorage.getItem("token");
                let dollarVal = $('.hidden-lbl.dollar-lbl').text();
                let objArr = {}
                if ((dollarVal.trim()) != "") {
                    objArr = { ['source']: dollarVal.trim() }
                }
                let tokenrequestOtions = {
                    method: "POST",
                    mode: "cors",
                    headers: {
                        'Authorization': 'Bearer' + get_token,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(objArr),
                };
                fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
                    .then(response => response.json())
                    .then(data => { this.setState({ Source_List: data.data }); })
            }
        });

    };
    offertypehandleChange = (offerType) => {
        this.setState({ offerType });
    };
    handleMonthChange(monthName, monthValue) {
        if (monthValue) {
            let { selectMonth } = this.state;
            if (monthName === 'selectMonth') {
                selectMonth = monthValue;
            }
            this.setState({
                selectMonth,
            });
        }

    }
    handleClearData = () => {

        Array.from(document.querySelectorAll("input[type='text']")).forEach(input => (input.value = ""));
        Array.from(document.querySelectorAll('input[name="weekCheck"]:checked'), input => input.checked = false);
        Array.from(document.querySelectorAll('input[name="monthCheck"]:checked'), input => input.checked = false);
        Array.from(document.querySelectorAll('input[name="hourcheck"]:checked'), input => input.checked = false);
        this.setState({
            startDate: new Date(),
            endDate: new Date(),
            subscriptionstartDate: new Date(),
            subscriptionendDate: '',
            subscriptionselectDate: new Date(),
            daterangeoption: { label: 'Yesterday', value: 'Yesterday' },
            medium: [],
            offerType: [],
            selectedOption: { label: 'Select Report', value: 'Select Report' },
            timezoneoption: { label: "(UTC" + moment.tz(userTimezone).format('Z') + ") " + userTimezone, value: userTimezone },
            monthoption: [],
            reportTimeOption: 'Hourly',
            hourTimeOption: '',
            weekoption: [],
            deliverySubject: '',
            emailList: '',
            error_msg: false,
            // reportFormatOption:'',
            subscriptionTitle: '',
            errorsubscribe_msg: false,
            defaulttime: start,

            SubscribeTitle: false,
            ReportType: false,
            EmailList: false,
            Subject: false,
            //ReportFormat: false,
            FollowingDays: false,
            FollowingMonths: false,
            FollowingHours: false,
            selectDate: false
        }, () => {
            if (this.state.selectedOption.value == 'Select Report') {
                $(".report-select-options").addClass("subscription-hide-blk");
            }
        });
        if (this.state.daterangeoption.value == 'Custom') {
            $('.datepicker').removeClass("disabled");
        }
        else {
            $('.datepicker').addClass("disabled");
        }



    }
    handleTitleChange = (e) => {
        this.setState({ subscriptionTitle: e.target.value });
        if (e.target.value == '') {
            this.setState({ SubscribeTitle: true });
        }
        else {
            this.setState({ SubscribeTitle: false });
        }
    }
    handleEmailChange = (e) => {
        const emailRegex = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]+)(, ?[\w+-.%]+@[\w-.]+\.[A-Za-z]+)*$/;
        // /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/

        this.setState({ emailList: e.target.value });
        if (e.target.value == '' || !emailRegex.test(e.target.value)) {
            this.setState({ EmailList: true });
        }
        else {
            this.setState({ EmailList: false });
        }
    }
    handleSubjectChange = (e) => {
        this.setState({ deliverySubject: e.target.value });
        if (e.target.value == '') {
            this.setState({ Subject: true });
            this.setState({
                errorMessage: { ...this.state.errorMessage, Subject: 'Enter Delivery Subject' },
                isError: { ...this.state.isError, Subject: true }
            });
        }
        else {
            this.setState({ Subject: false });
        }
    }


    handleSaveSubscription = async (e) => {
        const get_token = localStorage.getItem("token");
        let billingYearValue = (this.state.selectMonth.getFullYear());
        let billingMonthValue = ("0" + (this.state.selectMonth.getMonth() + 1)).slice(-2);
        if (this.state.selectedOption.value != 'external_partner_lead_summary_report') {
            offertypeVal = $('.hidden-lbl.offer-type').text();
        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report' && this.state.selectedOption.value != 'unique_student_report') {
            mediumVal = $('.hidden-lbl.medium-lbl').text();
        }
        let objArr = {}
        if (this.state.subscriptionTitle != '') {
            objArr = { ...objArr, ['subscription_title']: this.state.subscriptionTitle }
            this.setState({ SubscribeTitle: false });
        }
        else {
            this.setState({ SubscribeTitle: true });
        }
        if (this.state.selectedOption.value != 'Select Report') {
            objArr = { ...objArr, ['report_type']: this.state.selectedOption.value }
            this.setState({ ReportType: false });
        }
        else {
            this.setState({ ReportType: true });
        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report' && this.state.selectedOption.value != 'unique_student_report') {
            objArr = { ...objArr, ['present_date_range']: this.state.daterangeoption.value }
        }
        if (this.state.timezoneoption.value != '') {
            objArr = { ...objArr, ['timezone']: this.state.timezoneoption.value }
        }
        if (this.state.selectedOption.value == 'credit_lead_return_resason_report' || this.state.selectedOption.value == 'unique_student_report') {
            objArr = { ...objArr, ['billing_month']: billingYearValue + billingMonthValue }

        }
        if (this.state.daterangeoption.value == 'Custom') {
            objArr = { ...objArr, ['lead_create_start']: this.state.startDate.toISOString().split('T')[0] }
            objArr = { ...objArr, ['lead_create_end']: this.state.endDate.toISOString().split('T')[0] }
        }
        if (this.state.selectedOption.value != 'credit_lead_return_resason_report' && this.state.selectedOption.value != 'unique_student_report') {
            if ((mediumVal.trim()) != "") {
                objArr = { ...objArr, ['medium']: mediumVal.trim() }
            }
        }

        if (this.state.selectedOption.value == 'unique_student_report') {
            let dollarVal = $('.hidden-lbl.dollar-lbl').text();
            if ((dollarVal.trim()) != "") {
                dollarVal = dollarVal.replace(/\$/g, '');
                objArr = { ...objArr, ['dollar_cost']: dollarVal.trim() }
            }
        }

        if (this.state.selectedOption.value != 'external_partner_lead_summary_report') {
            if ((offertypeVal.trim()) != "") {
                objArr = { ...objArr, ['offer_type']: offertypeVal.trim() }
            }
        }
        if (this.state.reportTimeOption != '') {
            objArr = { ...objArr, ['type']: this.state.reportTimeOption }
        }
        if (this.state.hourTimeOption != '') {
            objArr = { ...objArr, ['every_hours']: this.state.hourTimeOption }
            this.setState({ FollowingHours: false })
        }
        else {
            this.setState({ FollowingHours: true })
        }
        if (this.state.weekoption != '') {
            objArr = { ...objArr, ['following_days']: this.state.weekoption }
            this.setState({ FollowingDays: false })
        }
        else {
            this.setState({ FollowingDays: true })
        }
        if (this.state.monthoption != '') {
            objArr = { ...objArr, ['following_months']: this.state.monthoption }
            this.setState({ FollowingMonths: false })
        }
        else {
            this.setState({ FollowingMonths: true })
        }

        let sourceVal = $('.hidden-lbl.source-lbl').text();
        if ((sourceVal.trim()) != "") {
            objArr = { ...objArr, ['source']: sourceVal.trim() }
        }

        if (this.state.reportTimeOption != 'Monthly') {
            if (this.state.subscriptionstartDate != null) {
                // objArr = { ...objArr, ['start_date']: this.state.subscriptionstartDate.toISOString().split('T')[0] }
                objArr = { ...objArr, ['start_date']: this.formatDate(this.state.subscriptionstartDate.toDateString()) }

            }

            if (this.state.subscriptionendDate != '' && this.state.subscriptionendDate != null) {
                // objArr = { ...objArr, ['end_date']: this.state.subscriptionendDate.toISOString().split('T')[0] }
                objArr = { ...objArr, ['end_date']: this.formatDate(this.state.subscriptionendDate.toDateString()) }
            }
        }
        if (this.state.reportTimeOption == 'Monthly') {
            if (this.state.subscriptionselectDate.value != '') {
                // objArr = { ...objArr, ['start_date']: this.state.subscriptionselectDate.toISOString().split('T')[0] }
                objArr = { ...objArr, ['start_date']: this.formatDate(this.state.subscriptionselectDate.toDateString()) }
            }

        }

        if (this.state.reportTimeOption != '') {
            if (this.state.defaulttime != null) {
                const dateTime = this.state.defaulttime.format("HH:mm:00");
                objArr = { ...objArr, ['start_time']: dateTime }
                this.setState({ Timeoption: false })
            }
            else {
                this.setState({ Timeoption: true })
            }
        }
        if (this.state.reportTimeOption == 'Monthly') {
            if (this.state.subscriptionselectDate.value != '') {
                // objArr = { ...objArr, ['start_date']: this.state.subscriptionselectDate.toISOString().split('T')[0] }
                objArr = { ...objArr, ['start_date']: this.formatDate(this.state.subscriptionselectDate.toDateString()) }
                this.setState({ selectDate: false })
            }
            else {
                this.setState({ selectDate: true })
            }
        }

        if (this.state.deliverySubject != '') {
            objArr = { ...objArr, ['subject']: this.state.deliverySubject }
            this.setState({ Subject: false });
        }
        else {
            this.setState({ Subject: true })
        }
        // const emailRegex = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/;
        // // const emailRegex = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]+)(, ?[\w+-.%]+@[\w-.]+\.[A-Za-z]+)*$/;
        // if (this.state.emailList != '' || emailRegex.test(this.state.emailList)) {
        //     objArr = { ...objArr, ['email_list']: this.state.emailList }
        //     this.setState({ EmailList: false });
        // }
        // else {
        //     this.setState({ EmailList: true });
        // }


        const emailRegex = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]+)(, ?[\w+-.%]+@[\w-.]+\.[A-Za-z]+)*$/;

        if (this.state.emailList != '' && emailRegex.test(this.state.emailList)) {
            objArr = { ...objArr, ['email_list']: this.state.emailList }
            this.setState({ EmailList: false });
        }
        else {
            objArr = { ...objArr, ['email_list']: this.state.emailList }
            this.setState({ EmailList: true });
        }

        if (this.state.EmailList == true) {
            return false;
        }

        const reportRequestOptions = {
            method: 'POST',
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                'Authorization': 'Bearer' + get_token,
            },
            body: JSON.stringify(objArr),
        }

        const savesubscriptionCall = () => {
            this.setState({ issubscribeLoader: true })
            const subscribeEditId = localStorage.getItem("subscribeedit_id");
            if (subscribeEditId !== '' && subscribeEditId !== null) {
                const get_token = localStorage.getItem("token");
                const requestOptions = {
                    method: "PUT",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json",
                        'Authorization': 'Bearer' + get_token,
                    },
                    body: JSON.stringify(objArr),
                };
                if (subscribeEditId !== '') {
                    this.setState({ issubscribeLoader: true, issucessMEssage: '' })
                    fetch(`./wp-json/asd/api/subscriptions/` + subscribeEditId, requestOptions).then((response) => {
                        if (response.ok) {
                            return response.json();
                        } else if (response.status === 401 || response.status === 403) {
                            this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });

                            localStorage.removeItem("token");
                            window.location.href = "/asd-login";
                        } else if (response.status === 500) {
                            this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });

                            throw 'Error';
                        } else if (response.status === 404) {
                            this.setState({ issucessMEssage: "There are no subscriptions to display.", issubscribeLoader: false });

                            throw 'Error';
                        } else {
                            this.setState({ issucessMEssage: "Something went's wrong. Please try again later", issubscribeLoader: false });

                            throw 'Error';
                        }
                    })
                        .then(data => {
                            this.setState({ issucessMEssage: data.message, issubscribeLoader: false });
                            { this.handleClearData() }
                            localStorage.setItem('SaveSubscription', 0);
                            localStorage.removeItem("subscribeedit_id");
                            window.location.href = './myaccount';
                        })
                        .catch((error) => {
                            console.log(error);
                        })

                }
            }
            else {
                fetch(`./wp-json/asd/api/subscriptions`, reportRequestOptions).then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    else if (response.status === 401 || response.status === 403) {
                        this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                        localStorage.removeItem("token");
                        window.location.href = "/asd-login";
                    } else if (response.status === 500) {
                        this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });

                        throw 'Error';
                    } else if (response.status === 404) {
                        this.setState({ issucessMEssage: "There are no subscriptions to display.", issubscribeLoader: false });
                        throw 'Error';
                    } else {
                        this.setState({ issucessMEssage: "Something went's wrong. Please try again later", issubscribeLoader: false });

                        throw 'Error';
                    }
                })
                    .then(data => {
                        this.setState({ issucessMEssage: data.message, issubscribeLoader: false });
                        { this.handleClearData() }
                        localStorage.setItem('SaveSubscription', 0);
                        window.location.href = './myaccount';
                    })
                    .catch((error) => {
                        console.log(error);
                    })

            }
        }

        if (this.state.reportTimeOption == 'Hourly') {
            if (this.state.subscriptionTitle != '' && this.state.defaulttime != null && this.state.selectedOption.value != 'Select Report' && this.state.deliverySubject != '' && this.state.emailList != '' && this.state.hourTimeOption != '' && this.state.weekoption != '' && !this.state.error_msg && !this.state.errorsubscribe_msg) {
                { savesubscriptionCall() }

            }
        }
        if (this.state.reportTimeOption == 'Daily') {
            if (this.state.subscriptionTitle != '' && this.state.defaulttime != null && this.state.selectedOption.value != 'Select Report' && this.state.deliverySubject != '' && this.state.emailList != '' && this.state.weekoption != '' && !this.state.error_msg && !this.state.errorsubscribe_msg) {
                { savesubscriptionCall() }
            }
        }

        if (this.state.reportTimeOption == 'Monthly') {
            if (this.state.subscriptionTitle != '' && this.state.defaulttime != null && this.state.selectedOption.value != 'Select Report' && this.state.deliverySubject != '' && this.state.emailList != '' && this.state.monthoption != '' && !this.state.error_msg) {
                { savesubscriptionCall() }
            }
        }



    }
    componentDidMount() {

        const get_token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");
        const inpersonateUserid = localStorage.getItem("inpersonate_id");
        if (inpersonateFlag == 'true') {
            const inpersonateUser = localStorage.getItem("inpersonate_user");
            const inpersonateUserid = localStorage.getItem("inpersonate_id");
            const sourcerequestOptions = {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify({ id: inpersonateUserid, token: get_token }),
            };
            fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
                .then(response => response.json())
                .then(data => { source_Provider = data.user_code; this.setState({ sourceProvider: { label: data.user_code, value: data.user_code } }) });
        }
        else {
            if (userId !== '' && userId !== null) {
                const sourcerequestOptions = {
                    method: 'POST',
                    mode: 'cors',
                    body: JSON.stringify({ id: userId, token: get_token }),
                };
                fetch(`./wp-json/asd/users/get`, sourcerequestOptions)
                    .then(response => response.json())
                    .then(data => { source_Provider = data.user_code; this.setState({ sourceProvider: { label: data.user_code, value: data.user_code } }) });

            }
        }
        const requestOptions = {
            method: "GET",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer' + get_token,
            },
        };
        const tokenrequestOtions = {
            method: "POST",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer' + get_token,
            },
        };
        this.setState({ issubscribeLoader: true });
        fetch(`./wp-json/asd/api/offer_type`, requestOptions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 404) {
                    this.setState({ issucessMEssage: "There are no offers.", issubscribeLoader: false });
                    return false
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {
                this.setState({ issubscribeLoader: false, offer_Type: data.data });
            })

        fetch(`./wp-json/asd/api/medium`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {

                this.setState({ issubscribeLoader: false, medium_: data.data });
            })

        fetch(`./wp-json/asd/api/source`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {

                this.setState({ issubscribeLoader: false, Source_List: data.data });
            })

        fetch(`./wp-json/asd/api/dollar_cost`, tokenrequestOtions)
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                    localStorage.removeItem("token");
                    window.location.href = "/asd-login";
                }
                else if (response.status === 500) {
                    this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                    return false
                }
            })
            .then((data) => {
                this.setState({ issubscribeLoader: false, dollar_Cost: data.data });
            })
        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: {
                'Authorization': 'Bearer' + get_token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token: get_token }),
        };

        fetch(`./wp-json/asd/api/report_list`, requestOption)
            .then(response => response.json())
            .then(data => { this.setState({ issubscribeLoader: false, reportList: data.data }); })


        const subscribeEditId = localStorage.getItem("subscribeedit_id");
        if (subscribeEditId !== '' && subscribeEditId !== null) {
            const get_token = localStorage.getItem("token");
            const requestOptions = {
                method: "GET",
                mode: "cors",
                headers: {
                    'Authorization': 'Bearer' + get_token,
                },
            };
            if (subscribeEditId !== '') {
                this.setState({ issubscribeLoader: true });
                fetch(`./wp-json/asd/api/subscriptions/` + subscribeEditId, requestOptions)
                    //.then(response => response.json())
                    .then((response) => {
                        if (response.ok) {
                            return response.json();
                        } else if (response.status === 401 || response.status === 403) {
                            this.setState({ issucessMEssage: "You have been logged out, please login again", issubscribeLoader: false });
                            localStorage.removeItem("token");
                            window.location.href = "/asd-login";
                        } else if (response.status === 500) {
                            this.setState({ issucessMEssage: "Oh no! Something bad happened. Please come back later.. ", issubscribeLoader: false });
                            return false
                        }
                        else if (response.status === 404) {
                            this.setState({ issucessMEssage: "There are no subscriptions to display.", issubscribeLoader: false });
                            return false
                        } else {
                            this.setState({ issucessMEssage: "Something went's wrong. Please try again later", issubscribeLoader: false });

                        }
                    })
                    .then(userData => {
                        console.log(userData);
                        this.setState({
                            subscriptionTitle: userData.data.subscription_title,
                            selectedOption: { label: userData.data.report_type, value: userData.data.report_type },
                            subscriptionstartDate: new Date(userData.data.start_date),
                            reportTimeOption: userData.data.type,
                            emailList: userData.data.email_list,
                            deliverySubject: userData.data.subject,
                            //reportFormatOption: userData.data.export_type,
                            timezoneoption: { value: userData.data.timezone, label: "(UTC" + moment.tz(userData.data.timezone).format('Z') + ") " + userData.data.timezone },
                            daterangeoption: { label: userData.data.present_date_range, value: userData.data.present_date_range },
                            sourceProvider: { label: userData.data.provider, value: userData.data.provider },
                            hourTimeOption: userData.data.every_hours,
                            // dollarCost: userData.data.dollar_cost,
                            defaulttime: moment(userData.data.start_time, 'HH:mm:a'),
                        });
                        // if(userData.data.timezone != ''){
                        //     const zonecountry = userData.data.timezone.split('/')[0];
                        //     const zonename = userData.data.timezone.split('/').pop();
                        //     this.setState({
                        //          timezoneoption: { value: userData.data.timezone, label: zonename + ' / ' + zonecountry },
                        //     })
                        // }

                        options.map((op) => {
                            if (op.value == userData.data.report_type) {
                                this.setState({
                                    selectedOption: { label: op.label, value: userData.data.report_type }
                                });
                            }
                        })
                        if (userData.data.following_days.length > 0) {
                            userData.data.following_days.map(elem => (
                                this.state.weekoption.push(elem)
                            ));
                        }
                        if (userData.data.start_time == null) {
                            this.setState({ defaulttime: start })
                        }
                        if (userData.data.following_months.length > 0) {
                            userData.data.following_months.map(elem => (
                                this.state.monthoption.push(elem)
                            ));
                        }
                        // if (userData.data.medium != '') {
                        //     this.setState({ medium: [{ label: userData.data.medium, value: userData.data.medium }] });
                        // }
                        if (userData.data.medium != '') {
                            if (userData.data.medium.includes("¤")) {
                                var chunks = userData.data.medium.split("¤");
                                // var arr = [chunks.shift(), chunks.join(' ')];
                                var arr = chunks;
                            }
                            else {
                                var arr = [userData.data.medium]
                            }
                            let constcol = [];
                            if (arr != null) {
                                constcol = arr.map(elem => (
                                    {
                                        label: elem,
                                        value: elem,
                                    }
                                ));
                                this.setState({ medium: constcol });
                            }
                        }
                        if (userData.data.present_date_range == "Custom") {
                            this.setState({ startDate: new Date(userData.data.lead_create_start), endDate: new Date(userData.data.lead_create_end) })

                        }
                        if (userData.data.type == "Monthly") {
                            this.setState({ subscriptionselectDate: new Date(userData.data.start_date) })
                        }
                        if (userData.data.offer_type != '') {
                            if (userData.data.offer_type.includes("¤")) {
                                var chunks = userData.data.offer_type.split("¤");
                                var arr = [chunks.shift(), chunks.join(' ')];
                            }
                            else {
                                var arr = [userData.data.offer_type]
                            }
                            let constcol = [];
                            if (arr != null) {
                                constcol = arr.map(elem => (
                                    {
                                        label: elem,
                                        value: elem,
                                    }
                                ));
                                this.setState({ offerType: constcol });
                            }
                        }
                        if (userData.data.source != '') {
                            if (userData.data.source.includes("¤")) {
                                var chunks = userData.data.source.split("¤");
                                // var arr = [chunks.shift(), chunks.join(' ')];
                                var arr = chunks;
                            }
                            else {
                                var arr = [userData.data.source]
                            }
                            let constcol = [];
                            if (arr != null) {
                                constcol = arr.map(elem => (
                                    {
                                        label: elem,
                                        value: elem,
                                    }
                                ));
                                this.setState({ sourceList: constcol });
                            }
                        }
                        if (this.state.timezoneoption) {

                            { this.timezonehandleChange(this.state.timezoneoption) }
                        }
                        if (this.state.daterangeoption) {
                            { this.presentDatehandleChange(this.state.daterangeoption) }
                        }
                        if (userData.data.end_date != "0000-00-00") {
                            this.setState({ subscriptionendDate: new Date(userData.data.end_date) })
                        }

                        if (userData.data.end_date == null) {

                            this.setState({ subscriptionendDate: '' });
                        }

                        if (userData.data.billing_month != '') {
                            this.setState({ selectMonth: new Date() })
                        }
                        if (userData.data.billing_month && userData.data.billing_month != '0') {
                            this.setState({ selectMonth: new Date(userData.data.billing_month.substring(0, 4) + '-' + userData.data.billing_month.substring(4, 6) + '-01') })
                        }

                        if (this.state.selectedOption.value != 'Select Report') {
                            $(".report-select-options").removeClass("subscription-hide-blk");
                        }


                    });
            }
        }

        document.addEventListener('click', this.handleOutsideClick);
    }

    convert = (str) => {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("/");
    }

    render() {
        const { selectedOption, timezoneoption, daterangeoption, medium, sourceList, offerType, dollarCost, reportTimeOption, hourTimeOption, isError, errorMessage, defaulttime, subscriptionTitle, deliverySubject, sourceProvider } = this.state;
        const monthCheckBox = (item, key) => {
            return (
                <span>
                    <input key={item.id} type="checkbox" id={item.id} name="monthCheck" onChange={this.handleInputMonthChange} value={item.value} checked={this.state.monthoption.includes(item.value)} />
                    <label className="form-check-label" for={item.id}>{item.value}</label>
                </span>
            )
        }
        const weekCheckBox = (item, key) => {
            return (
                <span>
                    <input key={item.id} type="checkbox" id={item.id} name="weekCheck" onChange={this.handleInputWeekChange} checked={this.state.weekoption.includes(item.value)} value={item.value} />
                    <label className="form-check-label" for={item.id}>{item.value}</label>
                </span>
            )
        }
        return (
            <div>
                <div className="subscription-wrap">
                    {/* <span>You will manage your subscription for reports.</span> */}
                    <div className="subscription-wrap-blk">
                        {/* <div className="main-title">
                             <p>MANAGE SUBSCRIPTON</p>
                        </div> */}
                        {this.state.issubscribeLoader ? <div className="list-download-loader"><div className="spinner"></div></div> : ''}
                        {this.state.issucessMEssage.length > 0 ? <div className="list-download-loader"><p className="subscribe-sent-msg">{this.state.issucessMEssage}</p></div> : ''}

                        <div className="subscription-wrapper">
                            <div className="col-left">
                                <h5>SUBSCRIPTION DETAILS <span className="required">*</span></h5>
                                <div className="input-field">
                                    <input type="text" placeholder="Subscription Title" value={this.state.subscriptionTitle} onChange={this.handleTitleChange} />
                                    {this.state.SubscribeTitle ? <p className="error-msg">Please enter subscription title</p> : ''}
                                </div>
                                <div className="subscription-row-wrapper">
                                    <div className="dropdownrow">
                                        <div className="dropdown-blk">
                                            <Select
                                                onChange={this.handleChange}
                                                options={this.state.reportList}
                                                className="custom-select"
                                                // defaultValue={this.state.selectedOption}
                                                value={this.state.selectedOption}
                                            />
                                            {this.state.ReportType ? <p className="error-msg">Please select report type</p> : ''}
                                        </div>

                                    </div>
                                </div>
                                <div className="report-select-options subscription-hide-blk">
                                    <div className="option-title">
                                        <h5>FILTER OPTIONS</h5>
                                    </div>
                                    {selectedOption.value != 'credit_lead_return_resason_report' && selectedOption.value != 'unique_student_report' ?
                                        <div className="row">
                                            <label>Present Date Range</label>
                                            <Select
                                                onChange={this.presentDatehandleChange}
                                                options={daterangeOptions}
                                                className="custom-select"
                                                label={daterangeoption}
                                                defaultValue={daterangeoption}
                                                value={this.state.daterangeoption}
                                                isDisabled={selectedOption.value == 'interaday_external_partner_lead_detailed_report' || 'intraday_linkout_lead_detail_report'}

                                            />
                                        </div>
                                        : ''}
                                    {(selectedOption.value != 'credit_lead_return_resason_report') && (selectedOption.value != 'interaday_external_partner_lead_detailed_report') && selectedOption.value != 'unique_student_report' && (selectedOption.value != 'intraday_linkout_lead_detail_report') ?
                                        <div className="row">
                                            <label>Lead Create Start Date</label>
                                            <div className="datepicker disabled">
                                                <DatePicker name="startDateTime" dateFormat="yyyy/MM/dd" selected={this.state.startDate} onChange={date => this.handleDateChange('startDateTime', date)} />
                                                {this.state.error_msg ? <span className="date-error-msg">Start date should be less than end date</span> : ''}
                                            </div>
                                        </div>
                                        : ''}
                                    {(selectedOption.value != 'credit_lead_return_resason_report') && (selectedOption.value != 'interaday_external_partner_lead_detailed_report') && selectedOption.value != 'unique_student_report' && (selectedOption.value != 'intraday_linkout_lead_detail_report') ?
                                        <div className="row">
                                            <label>Lead Create End Date</label>
                                            <div className="datepicker disabled">
                                                <DatePicker name="EndDateTime" dateFormat="yyyy/MM/dd" selected={this.state.endDate} onChange={date => this.handleDateChange('EndDateTime', date)} />
                                            </div>
                                        </div>
                                        : ''}
                                    {selectedOption.value != 'credit_lead_return_resason_report' && selectedOption.value != 'unique_student_report' ?
                                        <div className="row">
                                            <label>Medium</label>
                                            <Select
                                                value={medium}
                                                onChange={this.mediumhandleChange}
                                                options={this.state.medium_}
                                                className="custom-select"
                                                label={medium}
                                                isMulti
                                                isClearable
                                            />
                                        </div>
                                        : ''}
                                    {selectedOption.value == 'external_partner_lead_detailed_report' || selectedOption.value == 'interaday_external_partner_lead_detailed_report' ?
                                        <div className="row">
                                            <label>Offer Type</label>
                                            <Select
                                                value={offerType}
                                                onChange={this.offertypehandleChange}
                                                options={this.state.offer_Type}
                                                className="custom-select"
                                                label={offerType}
                                                isMulti
                                                isClearable
                                            />
                                        </div>
                                        : ''}
                                    {selectedOption.value == 'credit_lead_return_resason_report' || selectedOption.value == 'unique_student_report' ?
                                        <div className="row">
                                            <label>Month</label>
                                            <div className="datepicker">
                                                <DatePicker dateFormat="yyyy/MM" selected={this.state.selectMonth} showMonthYearPicker name="selectMonth" onChange={date => this.handleMonthChange('selectMonth', date)} />
                                            </div>
                                        </div>
                                        : ''}
                                    <div className="row">
                                        <label>Source (Provider)</label>
                                        <Select
                                            value={sourceList}
                                            onChange={this.sourcehandleChange}
                                            options={this.state.Source_List}
                                            className="custom-select"
                                            label={sourceList}
                                            isMulti
                                            isClearable
                                        />
                                    </div>
                                    {selectedOption.value == 'unique_student_report' ?
                                        <div className="row">
                                            <label>Dollar Cost</label>
                                            <Select
                                                value={dollarCost}
                                                onChange={this.dollarhandleChange}
                                                options={this.state.dollar_Cost}
                                                className="custom-select"
                                                label={dollarCost}
                                                isMulti
                                                isClearable
                                            />
                                        </div>
                                        : ""}
                                    <div className="row">
                                        <label>Vendor</label>
                                        <Select
                                            options={this.state.sourceProvider}
                                            className="custom-select"
                                            defaultValue={this.state.sourceProvider}
                                            value={this.state.sourceProvider}
                                            isDisabled
                                        />
                                    </div>
                                    {selectedOption.value != 'external_partner_lead_summary_report' ? <label className="hidden-lbl offer-type"> {this.state.offerType != null ? (this.state.offerType.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label> : ''}
                                    <label className="hidden-lbl medium-lbl"> {this.state.medium != null ? (this.state.medium.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
                                    <label className="hidden-lbl source-lbl"> {this.state.sourceList != null ? (this.state.sourceList.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
                                    <label className="hidden-lbl dollar-lbl"> {this.state.dollarCost != null ? (this.state.dollarCost.map((o, i, arr) => <span>{o.value}{i != (arr.length - 1) ? '¤' : ''}</span>)) : ''} </label>
                                </div>

                            </div>
                            <div className="col-right">
                                <h5>Schedule Details</h5>
                                <p>Choose whether to run the report on an hourly, daily,  monthly or one time basis</p>

                                {/* <p><span className="exlamation-blk"><i className="fa fa-exclamation"></i></span>All times are expressed in (UTC-08:00) Pacific Standard Time</p> */}
                                <div className="deleivery-blk-list timezone-list">
                                    <div className="row">
                                        <label>Select Timezone</label>
                                        <Select
                                            onChange={this.timezonehandleChange}
                                            options={offsetTmz}
                                            className="custom-select"
                                            label={timezoneoption}
                                            defaultValue={timezoneoption}
                                            value={this.state.timezoneoption}
                                            onFocus={this.timezoneplaceholder}
                                            onBlur={this.timezoneblurplaceholder}
                                        />
                                        {/* <TimezoneSelect
                                            value= {this.state.timezoneoption}                                       
                                            onChange={this.timezonehandleChange}
                                            className="custom-select"
                                            /> */}
                                    </div>
                                </div>

                                <div className="radio-list" >
                                    <input type="radio" id="hourly" value="Hourly" checked={reportTimeOption === 'Hourly'} onChange={e => this.handleReportTimeChange(e)} />
                                    <label for="hourly">Hourly</label>
                                    <input type="radio" id="daily" value="Daily" checked={reportTimeOption === 'Daily'} onChange={e => this.handleReportTimeChange(e)} />
                                    <label for="daily">Daily</label>
                                    <input type="radio" id="monthly" value="Monthly" checked={reportTimeOption === 'Monthly'} onChange={e => this.handleReportTimeChange(e)} />
                                    <label for="monthly">Monthly</label>
                                </div>
                                <div className="">
                                    <div className="option-filter-list">
                                        {reportTimeOption === 'Hourly' ? <h4>Hourly Option <span className="required">*</span></h4> : ''}
                                        {reportTimeOption === 'Daily' ? <h4>Daily Option </h4> : ''}
                                        {reportTimeOption === 'Monthly' ? <h4>Monthly Option </h4> : ''}

                                        <div className="hourl-options-blk">
                                            {reportTimeOption === 'Hourly' ?
                                                <div className="radio-list" onChange={this.handleHourTimeChange.bind(this)}>
                                                    <input type="radio" id="1hours" name="hourcheck" value="1" checked={hourTimeOption === '1'} />
                                                    <label for="1hours">Every 1 hours</label>
                                                    <input type="radio" id="2hours" name="hourcheck" value="2" checked={hourTimeOption === '2'} />
                                                    <label for="2hours">Every 2 hours</label>
                                                    <input type="radio" id="4hours" name="hourcheck" value="4" checked={hourTimeOption === '4'} />
                                                    <label for="4hours">Every 4 hours</label>
                                                    <input type="radio" id="8hours" name="hourcheck" value="8" checked={hourTimeOption === '8'} />
                                                    <label for="8hours">Every 8 hours</label>
                                                    <input type="radio" id="12hours" name="hourcheck" value="12" checked={hourTimeOption === '12'} />
                                                    <label for="12hours">Every 12 hours</label>
                                                    {this.state.FollowingHours ? <p className="error-msg">Please select following hours</p> : ''}
                                                    {/* <p className="error-msg">{isError.FollowingHours && errorMessage.FollowingHours}</p>  */}
                                                </div> : ''}

                                            {reportTimeOption == 'Hourly' ?
                                                <div>
                                                    <h5>On Following Days <span className="required">*</span></h5>
                                                    <div className="checkbox-list">
                                                        {week.map((item, key) => weekCheckBox(item, key))}
                                                    </div>
                                                    {this.state.FollowingDays ? <p className="error-msg">Please select following days</p> : ''}
                                                    {/* <p className="error-msg">{isError.FollowingDays && errorMessage.FollowingDays}</p> */}
                                                </div> : ''}
                                            {reportTimeOption == 'Daily' ?
                                                <div>
                                                    <h5>On Following Days <span className="required">*</span></h5>
                                                    <div className="checkbox-list">
                                                        {week.map((item, key) => weekCheckBox(item, key))}
                                                    </div>
                                                    {this.state.FollowingDays ? <p className="error-msg">Please select following days</p> : ''}
                                                    {/* <p className="error-msg">{isError.FollowingDays && errorMessage.FollowingDays}</p> */}
                                                </div> : ''}
                                            {reportTimeOption === 'Monthly' ?
                                                <div>
                                                    <h5>On Following Month <span className="required">*</span></h5>
                                                    <div className="checkbox-list">
                                                        {month.map((item, key) =>
                                                            monthCheckBox(item, key)
                                                        )}
                                                    </div>
                                                    {this.state.FollowingMonths ? <p className="error-msg">Please select following months</p> : ''}
                                                    {/* <p className="error-msg">{isError.FollowingMonths && errorMessage.FollowingMonths}</p>  */}
                                                </div> : ''}
                                            {reportTimeOption !== 'Monthly' ?
                                                <div>
                                                    <h5>Specify the start and end date for subscription</h5>
                                                    <div className="subscription-datepicker">
                                                        <span>Start Date <span className="required">*</span></span>
                                                        <DatePicker name="startDateTime" showYearDropdown minDate={new Date()} dateFormat="yyyy/MM/dd" selected={this.state.subscriptionstartDate} onChange={date => this.handlesubscribeDateChange('subscribeStartDateTime', date)} />

                                                        {this.state.errorsubscribe_msg ? <span className="date-error-msg">Start date should be less than end date</span> : ''}
                                                    </div>
                                                    <div className="subscription-datepicker">
                                                        <span>End Date</span>
                                                        <DatePicker name="endDateTime" showYearDropdown minDate={new Date()} dateFormat="yyyy/MM/dd" selected={this.state.subscriptionendDate} onChange={date => this.handlesubscribeDateChange('subscribeEndDateTime', date)} />
                                                    </div>
                                                    {/* {reportTimeOption == 'Hourly' ?
                                                  
                                                :''} */}

                                                </div>
                                                : ''}
                                            {reportTimeOption === 'Monthly' ?
                                                <div>
                                                    <h5>On Which Date</h5>
                                                    <div className="subscription-datepicker">
                                                        <span>Select Date <span className="required">*</span></span>
                                                        <DatePicker name="startDateTime" minDate={new Date()} showYearDropdown dateFormat="yyyy/MM/dd" selected={this.state.subscriptionselectDate} onChange={date => this.handlesubscribeselectDateChange('SelectDate', date)} />
                                                        <p>Please select the date to send this report.</p>
                                                        {this.state.selectDate ? <span className="date-error-msg">Please select date</span> : ''}
                                                    </div>
                                                </div> : ''}
                                            <div className="subscription-datepicker">
                                                <span>Start Time <span className="required">*</span></span>
                                                <TimePicker
                                                    showSecond={false}
                                                    minuteStep={30}
                                                    value={defaulttime}
                                                    className="timepicker"
                                                    onChange={this.onTimeChange}
                                                    format={format}
                                                    use12Hours
                                                    inputReadOnly
                                                />
                                                {this.state.Timeoption ? <span className="date-error-msg">Please select start time </span> : ''}
                                            </div>

                                        </div>
                                    </div>

                                    <h4>Delivery Options</h4>
                                    <div className="deleivery-blk-list">
                                        <div className="row">
                                            <label>Email List <span className="required">*</span></label>
                                            <input type="text" onChange={this.handleEmailChange} value={this.state.emailList} />
                                            <span>Use comma (,) to add multiple email address.</span>
                                            {this.state.EmailList ? <p className="error-msg">Please enter valid email address</p> : ''}
                                            {/* <p className="error-msg">{isError.EmailList && errorMessage.EmailList}</p> */}
                                        </div>
                                        <div className="row">
                                            <label>Subject <span className="required">*</span></label>
                                            <input type="text" onChange={this.handleSubjectChange} value={this.state.deliverySubject} />
                                            {this.state.Subject ? <p className="error-msg">Please enter delivery subject</p> : ''}
                                            {/* <p className="error-msg">{isError.Subject && errorMessage.Subject}</p> */}
                                        </div>
                                        {/* <div className="row">
                                            <label>Report Format</label>
                                            <div className="radio-list">
                                                <input type="radio" id="csv"  value="CSV (Comma Delimited)" checked={reportFormatOption === 'CSV (Comma Delimited)'}  onChange={e => this.handleReportFormatChange(e)}  />
                                                <label for="csv">CSV (Comma Delimited)</label>
                                                <input type="radio" id="excel"  value="Excel" checked={reportFormatOption === 'Excel'}  onChange={e => this.handleReportFormatChange(e)}/>
                                                <label for="excel">Excel</label>
                                            </div>
                                            {this.state.ReportFormat ? <p className="error-msg">Please Select Report Format</p>:''}
                                            
                                        </div> */}
                                        <div className="row">
                                            <div className="subscribe-btn-blk">
                                                <button className="subscribe-btn" onClick={this.handleSaveSubscription}>Save Subscription</button>
                                                <button className="subscribe-btn clear" onClick={this.handleClearData}>Clear</button>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}
export default Subscriptions
